import { isNull } from "lodash";
import Box from "@mui/material/Box";
import { styled as muiStyled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React, { useCallback, useMemo } from "react";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

// Imported assets
import blueClusterIcon from "../../../../assets/images/map/MultipleChargingStationsIcon_Blue.png";
import greenClusterIcon from "../../../../assets/images/map/MultipleChargingStationsIcon_Green.png";
import redClusterIcon from "../../../../assets/images/map/MultipleChargingStationsIcon_Red.png";
import yellowClusterIcon from "../../../../assets/images/map/MultipleChargingStationsIcon_Yellow.png";

// Styled components
const ClusterTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    border: "1px solid #dadde9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(12),
    padding: "10px",
  },
}));

const ClusterMarker = ({ clusterId, data, onMarkerClick, position, selectedStation, setSelectedStation, size }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const handleClick = useCallback(() => {
    setSelectedStation(null);
    onMarkerClick && onMarkerClick(data);
  }, [data]);
  
    const markerOpacity = useMemo(
      () =>
        selectedStation?.id === data.id || isNull(selectedStation) ? 1 : 0.5,
      [data.id, selectedStation]
    );

  // const statusCounts = useMemo(() => {
  //   let counts = {
  //     "Cyber Attack": 0,
  //     Faulted: 0,
  //     "In Maintenance": 0,
  //     Available: 0,
  //   };

  //   data.forEach((marker) => {
  //     let status = marker.locationStatusType.codeName;
  //     if (status === "Cyber Attack") {
  //       statusCounts["Cyber Attack"]++;
  //     } else if (status === "Faulted") {
  //       statusCounts["Faulted"]++;
  //     } else if (marker.maintenanceActive) {
  //       statusCounts["In Maintenance"]++;
  //     } else if (status === "Available") {
  //       statusCounts["Available"]++;
  //     }
  //   });

  //   return counts;
  // }, [data]);

  let statusCounts = {
    "Cyber Attack": 0,
    Faulted: 0,
    "In Maintenance": 0,
    Available: 0,
  };

  // data.forEach((marker) => {
  //   let status = marker.locationStatusType.codeName;
  //   if (status === "Cyber Attack") {
  //     statusCounts["Cyber Attack"]++;
  //   } else if (status === "Faulted") {
  //     statusCounts["Faulted"]++;
  //   } else if (marker.maintenanceActive) {
  //     statusCounts["In Maintenance"]++;
  //   } else if (status === "Available") {
  //     statusCounts["Available"]++;
  //   }
  // });
  data.forEach((marker) => {
    let status = marker.locationStatusType.codeName;
    if (status === "Cyber Attack") {
      statusCounts["Cyber Attack"]++;
    } else if (marker.maintenanceActive) {
      statusCounts["In Maintenance"]++;
    } else if (status === "Faulted") {
      statusCounts["Faulted"]++;
    } else if (status === "Available") {
      statusCounts["Available"]++;
    }
  });

  // Determines the icon for a marker based on the location's status
  const chooseMarkerIcon = () => {
    // Cluster icon displayed is based on stations contained
    // Hierarchy currently is:
    // Cyber Attack (yellow) -> Faulted (red) -> In Maintenance (blue) -> Available (green)
    if (statusCounts["Cyber Attack"] > 0) {
      return yellowClusterIcon;
    } else if (statusCounts["Faulted"] > 0) {
      return redClusterIcon;
    } else if (statusCounts["In Maintenance"] > 0) {
      return blueClusterIcon;
    } else {
      return greenClusterIcon;
    }
  };

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      className={"marker cluster"}
      onClick={handleClick}
      position={position}
      ref={markerRef}
      zIndex={size}
    >
      <ClusterTooltip
        arrow
        placement="top"
        title={
          <>
            <Box>
              <div>
                Total Stations:{" "}
                {statusCounts["Faulted"] +
                  statusCounts["Cyber Attack"] +
                  statusCounts["In Maintenance"] +
                  statusCounts["Available"]}
              </div>
              <br />
              <div>Station Statuses:</div>
              <br />
              <div>Cyber Attack: {statusCounts["Cyber Attack"]}</div>
              <div>Faulted: {statusCounts["Faulted"]}</div>
              <div>In Maintenance: {statusCounts["In Maintenance"]}</div>
              <div>Available: {statusCounts["Available"]}</div>
            </Box>
          </>
        }
      >
        <img height={48} src={chooseMarkerIcon()} style={{ opacity: markerOpacity }} width={48} />
      </ClusterTooltip>
    </AdvancedMarker>
  );
};

export default ClusterMarker;
